import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import {initReactI18next} from 'react-i18next';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'uk', // Consider using a fallback language like 'en' if 'ua' is unavailable
    // debug: true,
    react: {
      useSuspense: false
    },
    interpolation: {
      escapeValue: false // React already escapes values
    },
    backend: {
      // Configure your backend settings if necessary
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    }
  });

export default i18n;
